import { collapseSmartSnippetRelatedQuestion, expandSmartSnippetRelatedQuestion, } from '../../../features/question-answering/question-answering-actions.js';
import { questionAnsweringReducer as questionAnswering } from '../../../features/question-answering/question-answering-slice.js';
import { getResultProperty } from '../../../features/result-templates/result-templates-helpers.js';
import { searchReducer as search } from '../../../features/search/search-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { buildController, } from '../../controller/headless-controller.js';
/**
 * Creates a core `SmartSnippetQuestionsList` controller instance.
 *
 * @param engine - The headless engine.
 * @param analyticsClient - A SmartSnippetAnalyticsClient to send the appropriate analytics calls.
 * @returns A `CoreSmartSnippetQuestionsList` controller instance.
 * */
export function buildCoreSmartSnippetQuestionsList(engine, analyticsClient) {
    if (!loadSmartSnippetQuestionsListReducer(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const getState = () => engine.state;
    const getResult = (identifier) => {
        const { contentIdKey, contentIdValue } = identifier;
        return engine.state.search.results.find((result) => getResultProperty(result, contentIdKey) === contentIdValue);
    };
    return {
        ...controller,
        get state() {
            const state = getState();
            return {
                questions: state.search.questionAnswer.relatedQuestions.map((relatedQuestion, i) => ({
                    question: relatedQuestion.question,
                    answer: relatedQuestion.answerSnippet,
                    documentId: relatedQuestion.documentId,
                    questionAnswerId: state.questionAnswering.relatedQuestions[i].questionAnswerId,
                    expanded: state.questionAnswering.relatedQuestions[i].expanded,
                    source: getResult(relatedQuestion.documentId),
                })),
            };
        },
        expand(identifier) {
            const payload = { questionAnswerId: identifier };
            engine.dispatch(analyticsClient.logExpandSmartSnippetSuggestion(payload));
            engine.dispatch(expandSmartSnippetRelatedQuestion(payload));
        },
        collapse(identifier) {
            const payload = { questionAnswerId: identifier };
            engine.dispatch(analyticsClient.logCollapseSmartSnippetSuggestion(payload));
            engine.dispatch(collapseSmartSnippetRelatedQuestion(payload));
        },
    };
}
function loadSmartSnippetQuestionsListReducer(engine) {
    engine.addReducers({ search, questionAnswering });
    return true;
}
